

import { Visibility, VisibilityOff } from '@mui/icons-material';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import React, { useState } from 'react'

const PasswordField = ({passwordRef, id='password', label='Contraseña'}) => {

    const [showPassword, setShowPassword] = useState(false);

    const handleClick = () => {
        setShowPassword(!showPassword);
    }

    const handleMouseDown = (e) => {
        e.preventDefault(); //con esto se evita que el foco vaya al icono presionado, es decir el foco se queda en el lugar que está
    }

    return (
        <TextField
            margin='normal'
            variant='standard'
            id={id}
            label={label}
            type={showPassword ? 'text' : 'password'}
            fullWidth
            inputRef={passwordRef}
            inputProps={{ minLength: 6 }}
            required
            InputProps={{
                endAdornment: (
                    <InputAdornment position='end'>
                        <IconButton onClick={handleClick} onMouseDown={handleMouseDown}>
                            {showPassword ? <VisibilityOff /> : <Visibility ></Visibility>}
                        </IconButton>
                    </InputAdornment>
                )
            }}
        />
    )
}

export default PasswordField